import React, { useEffect } from "react";
import { useAuth } from "hooks";
import { Link } from "react-router-dom";
import api from "services/api";
import { Container } from "components";
import Footer from "components/footer";
import { useSelector } from "react-redux";
import moment from "moment";

const ViewProfile = () => {
  const { user } = useAuth();
  const userData = useSelector((state) => state.profile.profileDataRedux);
  console.log("userDataVView:", userData);

  const fetchUserDetails = async () => {
    try {
      const response = await api.get(`/users/${user?.user_id}`);
      const data = response?.data?.data?.user;
      console.log("fetchUserDetails:", data);
      if (data) {
        userData(data);
      }
    } catch (error) {
      console.log("error response:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Settings</Link>
              </li>
              <li class="breadcrumb-item active">Profile</li>
            </ol>
          </nav>
          <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0"></div>
          <div className="container-xxl flex-grow-1 container-p-y">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="user-profile-header-banner">
                    <img
                      src="../../assets/img/pages/profile-banner.png"
                      alt="Banner image"
                      className="rounded-top"
                      style={{
                        width: "100%",
                        height: "150px",
                      }}
                    />
                  </div>
                  <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                    <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto ">
                      <img
                        src={userData?.profile?.profile_pic_url}
                        style={{
                          width: "150px",
                          height: "150px",
                        }}
                        alt="user image"
                        className="d-block  ms-0 ms-sm-4 rounded user-profile-img"
                      />
                    </div>
                    <div className="flex-grow-1 mt-3 mt-sm-5">
                      <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                        <div className="user-profile-info">
                          <h4>
                            {userData?.first_name} {userData?.middle_name}{" "}
                            {userData?.last_name}
                          </h4>
                          <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                            <li className="list-inline-item d-flex gap-1">
                              <i className="ti ti-mail"></i>
                              {userData?.email}
                            </li>
                          </ul>
                        </div>
                        <Link
                          to="/updateProfile"
                          className="btn btn-primary me-3"
                        >
                          Modify
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 col-12">
                        <small className="card-text text-uppercase">
                          About
                        </small>
                        <ul className="list-unstyled mb-4 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-user text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              First Name:
                            </span>
                            <span>{userData?.first_name} </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-user text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Last Name:
                            </span>
                            <span>{userData?.last_name} </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-list-details text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Gender:
                            </span>
                            <span>{userData?.profile?.sex} </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-mail"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Email Verified:
                            </span>
                            <span className="badge bg-label-success">
                              {moment(userData?.email_verified_at).format(
                                "DD-MM-YYYY"
                              )}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i class="ti ti-shield-check-filled text-green-600 text-[20px] md:text-[32px] leading-none"></i>
                            <span className="fw-medium mx-2 text-heading">
                              KYC Status:
                            </span>
                            <span
                              className={`badge ${
                                userData?.profile?.kyc_status === "Pending"
                                  ? "bg-warning"
                                  : userData?.profile?.kyc_status === "Approved"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {userData?.profile?.kyc_status}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Country:
                            </span>
                            <span>{userData?.profile?.country_name}</span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-8 col-12">
                        <ul className="list-unstyled mb-4 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-user text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Middle Name:
                            </span>
                            <span>{userData?.middle_name} </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-phone-call  text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Phone No.:
                            </span>
                            <span>{userData?.profile?.phone_no} </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti  ti-calendar text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Date Of Birth:
                            </span>
                            <span>
                              {moment(userData?.profile?.dob).format(
                                "DD-MM-YYYY"
                              )}{" "}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-home"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Address:
                            </span>
                            <span>{userData?.profile?.address}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-building-community"></i>
                            <span className="fw-medium mx-2 text-heading">
                              City:
                            </span>
                            <span>{userData?.profile?.city}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map"></i>
                            <span className="fw-medium mx-2 text-heading">
                              State:
                            </span>
                            <span>{userData?.profile?.state}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-mail "></i>
                            <span className="fw-medium mx-2 text-heading">
                              Postal Code:
                            </span>
                            <span>{userData?.profile?.postal_code}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Container>
  );
};

export default ViewProfile;
